// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sztkE20sEO1Lso {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.p_p494GsL_xU6t {
  align-items: flex-end;
}
.Nh2CSzuO3LuMqJ {
  align-items: flex-end;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-top: -40px;
}
`, ""]);
// Exports
export var buttons = `sztkE20sEO1Lso`;
var _1 = `p_p494GsL_xU6t`;
export { _1 as "buttons--flipped" };
export var inboxCardButtons = `Nh2CSzuO3LuMqJ`;
export default ___CSS_LOADER_EXPORT___;
